
/*
 |--------------------------------------------------------------------------
 | Laravel Spark Components
 |--------------------------------------------------------------------------
 |
 | Here we will load the Spark components which makes up the core client
 | application. This is also a convenient spot for you to load all of
 | your components that you write while building your applications.
 */

require('./../spark-components/bootstrap');
require('./home');
require('./settings/profile/update-profile-details'); //adds phone field to update

// TODO: MOVE THESE THINGS TO THEIR OWN FILE
import { ToggleButton } from 'vue-js-toggle-button';

Vue.component('ToggleButton', ToggleButton);
// /TODO

// Main nav & content areas
import WelcomeMessage from './home/navigation/WelcomeMessage.vue';
import MainNav from './home/navigation/MainNav.vue';
import MainTabContent from './home/navigation/MainTabContent.vue';
import EmployeeNav from './home/navigation/EmployeeNav.vue';
import EmployeeTabContent from './home/navigation/EmployeeTabContent.vue';
import CustomerNav from './home/navigation/CustomerNav.vue';
import CustomerTabContent from './home/navigation/CustomerTabContent.vue';

Vue.component('WelcomeMessage', WelcomeMessage);
Vue.component('MainNav', MainNav);
Vue.component('MainTabContent', MainTabContent);
Vue.component('EmployeeNav', EmployeeNav);
Vue.component('EmployeeTabContent', EmployeeTabContent);
Vue.component('CustomerNav', CustomerNav);
Vue.component('CustomerTabContent', CustomerTabContent);

// Billing
// Vue.component('NoSubscription', require('./'));

// Dashboard
import Dashboard from './home/dashboard/Dashboard.vue';
Vue.component('Dashboard', Dashboard);

// Maps
import GMap from './home/maps/GMap.vue';
Vue.component('GMap', GMap);

// DatePicker
import DatePickerWrapper from './home/datepicker/DatePickerWrapper.vue';
Vue.component('DatePickerWrapper', DatePickerWrapper);

// Notes
import Notes from './home/notes/Notes.vue';
Vue.component('Notes', Notes);

// Emails
import Emails from './home/emails/Emails.vue';
Vue.component('Emails', Emails);

// Projects
import Projects from './home/projects/Projects.vue';
import ProjectsArchive from './home/projects/ProjectsArchive.vue';
import ProjectForm from './home/projects/ProjectForm.vue';
import ProjectFormNavWrapper from './home/projects/ProjectFormNavWrapper.vue';
import Project from './home/projects/Project.vue';

Vue.component('Projects', Projects);
Vue.component('ProjectsArchive', ProjectsArchive);
Vue.component('ProjectForm', ProjectForm);
Vue.component('ProjectFormNavWrapper', ProjectFormNavWrapper);
Vue.component('Project', Project);

// Crew
import Crew from './home/crew/Crew.vue';
import CrewList from './home/crew/CrewList.vue';
import AddCrewMember from './home/crew/AddCrewMember.vue';

Vue.component('Crew', Crew);
Vue.component('CrewList', CrewList);
Vue.component('AddCrewMember', AddCrewMember);

// Overview
import Overview from './home/overview/Overview.vue';
import RunningTotal from './home/overview/RunningTotal.vue';

Vue.component('Overview', Overview);
Vue.component('RunningTotal', RunningTotal);

// Crew
import Customer from './home/customer/Customer.vue';
import CustomerList from './home/customer/CustomerList.vue';
import AddCustomer from './home/customer/AddCustomer.vue';

Vue.component('Customer', Customer);
Vue.component('CustomerList', CustomerList);
Vue.component('AddCustomer', AddCustomer);

// Change orders
import CaughtUpMessage from './home/change-orders/CaughtUpMessage.vue';
import ChangeOrder from './home/change-orders/ChangeOrder.vue';
import ChangeOrders from './home/change-orders/ChangeOrders.vue';
import NewChangeOrder from './home/change-orders/NewChangeOrder.vue';
import ChangeOrderForm from './home/change-orders/ChangeOrderForm.vue';
import ChangeOrdersList from './home/change-orders/ChangeOrdersList.vue';

Vue.component('CaughtUpMessage', CaughtUpMessage);
Vue.component('ChangeOrder', ChangeOrder);
Vue.component('ChangeOrders', ChangeOrders);
Vue.component('NewChangeOrder', NewChangeOrder);
Vue.component('ChangeOrderForm', ChangeOrderForm);
Vue.component('ChangeOrdersList', ChangeOrdersList);

import DraftChangeOrders from './home/change-orders/DraftChangeOrders.vue';
import DraftChangeOrdersList from './home/change-orders/DraftChangeOrdersList.vue';

Vue.component('DraftChangeOrders', DraftChangeOrders);
Vue.component('DraftChangeOrdersList', DraftChangeOrdersList);

// Selections
import Selection from './home/selections/Selection.vue';
import Selections from './home/selections/Selections.vue';
import NewSelection from './home/selections/NewSelection.vue';
import SelectionForm from './home/selections/SelectionForm.vue';
import SelectionList from './home/selections/SelectionList.vue';
import Templates from './home/selections/Templates.vue';
import NewTemplate from './home/selections/NewTemplate.vue';
import TemplateList from './home/selections/TemplateList.vue';
import TemplateForm from './home/selections/TemplateForm.vue';

Vue.component('Selection', Selection);
Vue.component('Selections', Selections);
Vue.component('NewSelection', NewSelection);
Vue.component('SelectionForm', SelectionForm);
Vue.component('SelectionList', SelectionList);
Vue.component('Templates', Templates);
Vue.component('NewTemplate', NewTemplate);
Vue.component('TemplateList', TemplateList);
Vue.component('TemplateForm', TemplateForm);

import DraftSelections from './home/selections/DraftSelections.vue';
import DraftSelectionList from './home/selections/DraftSelectionList.vue';

Vue.component('DraftSelections', DraftSelections);
Vue.component('DraftSelectionList', DraftSelectionList);

// Work orders
import WorkOrders from './home/work-orders/WorkOrders.vue';
import WorkOrder from './home/work-orders/WorkOrder.vue';
import NewWorkOrder from './home/work-orders/NewWorkOrder.vue';
import WorkOrderForm from './home/work-orders/WorkOrderForm.vue';
import WorkOrdersList from './home/work-orders/WorkOrdersList.vue';
import WorkOrderCalendar from './home/work-orders/calendar/WorkOrderCalendar.vue';

Vue.component('WorkOrders', WorkOrders);
Vue.component('WorkOrder', WorkOrder);
Vue.component('NewWorkOrder', NewWorkOrder);
Vue.component('WorkOrderForm', WorkOrderForm);
Vue.component('WorkOrdersList', WorkOrdersList);
Vue.component('WorkOrderCalendar', WorkOrderCalendar);

// Material selections
// Vue.component('MaterialSelections', require('./home/material-selections/MaterialSelections.vue'));
// Vue.component('MaterialSelectionsCard', require('./home/material-selections/MaterialSelectionsCard.vue'));
// Vue.component('PendingMaterialSelectionsCard', require('./home/material-selections/PendingMaterialSelectionsCard.vue'));
